import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import PublicReceptionSchedule from '@/types/table/publicReceptionSchedule';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface PublicReceptionScheduleData extends PublicReceptionSchedule {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class PublicReceptionScheduleController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<PublicReceptionScheduleData>>(API_CONTEXT + '/app/publicReceptionSchedule/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<PublicReceptionScheduleData>(API_CONTEXT + '/app/publicReceptionSchedule/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/publicReceptionSchedule/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/publicReceptionSchedule/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/publicReceptionSchedule/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicReceptionSchedule/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicReceptionSchedule/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicReceptionSchedule/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/publicReceptionSchedule/deleteBatch', params, httpOptions);
  }
}
